import Loadable from 'react-loadable';
import Logout from './views/logout';
import Users from './views/users';
import User from './views/users/user';
import Companies from './views/companies';
import Company from './views/companies/item';
import TokensBalances from './views/companies/tokensBalance';
import TokensBalance from './views/companies/tokensBalance/item';
import AnimationsLists from './views/animationsLists';
import AnimationsList from './views/animationsLists/item';
import Fonts from './views/fonts';
import Font from './views/fonts/item';
import Invite from './views/users/invite';
import Languages from './views/languages';
import Language from './views/languages/language';
import Translations from './views/translates';
import Translation from './views/translates/translate';
import Licenses from './views/licenses';
import License from './views/licenses/license';
import Videos from './views/videos';
import Video from './views/videos/item';
import Notifications from './views/notifications';
import Notification from './views/notifications/item';
import Settings from './views/settings';
import Loading from './components/Loading';

const Dashboard = Loadable({
  loader: () => import('./views/dashboard'),
  loading: Loading,
});

const Roles = Loadable({
  loader: () => import('./views/roles'),
  loading: Loading,
});

const Role = Loadable({
  loader: () => import('./views/roles/role'),
  loading: Loading,
});

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const getRoutes = t => ([
  {
    path: '/',
    exact: true,
    name: t('Home'),
  },
  {
    path: '/users',
    exact: true,
    name: t('Users'),
  },
  {
    path: '/dashboard',
    exact: true,
    component: Dashboard,
    name: t('Dashboard'),
    permissions: [],
  },
  {
    path: '/translations',
    exact: true,
    component: Translations,
    name: t('Texts'),
    permissions: ['read_translations'],
  },
  {
    path: '/translations/create',
    exact: true,
    component: Translation,
    name: t('Create'),
    permissions: ['create_translations'],
  },
  {
    path: '/translations/:id',
    exact: true,
    component: Translation,
    name: t('Update'),
    permissions: ['update_translations'],
  },
  {
    path: '/settings',
    exact: true,
    component: Settings,
    name: t('Settings'),
    permissions: ['read_settings'],
  },
  {
    path: '/settings/general',
    exact: true,
    component: Settings,
    name: t('General'),
    permissions: ['read_settings'],
  },
  {
    path: '/settings/security',
    exact: true,
    component: Settings,
    name: t('Security'),
    permissions: ['read_settings'],
  },
  {
    path: '/settings/integrations',
    exact: true,
    component: Settings,
    name: t('Integrations'),
    permissions: ['read_settings'],
  },
  {
    path: '/languages',
    exact: true,
    component: Languages,
    name: t('Languages'),
    permissions: ['read_languages'],
  },
  {
    path: '/languages/create',
    exact: true,
    component: Language,
    name: t('Create'),
    permissions: ['create_languages'],
  },
  {
    path: '/languages/:id',
    exact: true,
    component: Language,
    name: t('Update'),
    permissions: ['update_languages'],
  },
  {
    path: '/animations-lists',
    exact: true,
    component: AnimationsLists,
    name: t('Animations list'),
    permissions: ['read_animations'],
  },
  {
    path: '/animations-lists/create',
    exact: true,
    component: AnimationsList,
    name: t('Create'),
    permissions: ['create_animations'],
  },
  {
    path: '/animations-lists/:id',
    exact: true,
    component: AnimationsList,
    name: t('Update'),
    permissions: ['update_animations'],
  },
  {
    path: '/fonts',
    exact: true,
    component: Fonts,
    name: t('Fonts'),
    permissions: ['read_animations'],
  },
  {
    path: '/fonts/create',
    exact: true,
    component: Font,
    name: t('Create'),
    permissions: ['read_animations'],
  },
  {
    path: '/fonts/:id',
    exact: true,
    component: Font,
    name: t('Update'),
    permissions: ['read_animations'],
  },
  {
    path: '/notifications',
    exact: true,
    component: Notifications,
    name: t('Fonts'),
    permissions: ['read_animations'],
  },
  {
    path: '/notifications/create',
    exact: true,
    component: Notification,
    name: t('Create'),
    permissions: ['read_animations'],
  },
  {
    path: '/notifications/:id',
    exact: true,
    component: Notification,
    name: t('Update'),
    permissions: ['read_animations'],
  },
  {
    path: '/users/index',
    exact: true,
    component: Users,
    // name: t('Users'),
    permissions: ['read_users'],
  },
  {
    path: '/users/roles',
    component: Roles,
    exact: true,
    name: t('Roles'),
    permissions: ['read_roles'],
  },
  {
    path: '/users/roles/create',
    component: Role,
    name: t('Create'),
    permissions: ['create_roles'],
  },
  {
    path: '/users/roles/:id',
    component: Role,
    name: t('Update'),
    permissions: ['read_roles'],
  },
  {
    path: '/users/companies',
    exact: true,
    component: Companies,
    name: t('Companies'),
    permissions: ['read_companies'],
  },
  {
    path: '/users/companies/create',
    exact: true,
    component: Company,
    name: t('Create'),
    permissions: ['create_companies'],
  },
  {
    path: '/users/companies/:company_id/tokens-balance',
    exact: true,
    component: TokensBalances,
    name: t('Tokens balance'),
    permissions: ['read_companies'],
  },
  {
    path: '/users/companies/:company_id/tokens-balance/create',
    exact: true,
    component: TokensBalance,
    name: t('Create tokens balance'),
    permissions: ['read_companies'],
  },
  {
    path: '/users/companies/:id',
    exact: true,
    component: Company,
    name: t('Update'),
    permissions: ['read_companies'],
  },
  {
    path: '/profile',
    exact: true,
    component: User,
  },
  {
    path: '/users/create',
    exact: true,
    component: User,
    name: t('Create'),
    permissions: ['create_users'],
  },
  {
    path: '/users/create-invite',
    exact: true,
    component: Invite,
    name: t('Create invite'),
    permissions: ['create_users'],
  },
  {
    path: '/users/:id',
    exact: true,
    component: User,
    name: t('Update'),
    permissions: ['read_users'],
  },
  {
    path: '/licenses',
    exact: true,
    component: Licenses,
    name: t('Licenses'),
    permissions: ['read_licenses'],
  },
  {
    path: '/licenses/create',
    exact: true,
    component: License,
    name: t('Create'),
    permissions: ['create_licenses'],
  },
  {
    path: '/licenses/:id',
    exact: true,
    component: License,
    name: t('Update'),
    permissions: ['update_licenses'],
  },
  {
    path: '/videos',
    exact: true,
    component: Videos,
    name: t('Videos'),
    permissions: ['read_animations'],
  },
  {
    path: '/videos/:id',
    exact: true,
    component: Video,
    name: t('Update'),
    permissions: ['update_animations'],
  },
  {
    path: '/logout',
    exact: true,
    component: Logout,
    permissions: [],
  },
]);

export default getRoutes;



// WEBPACK FOOTER //
// ./src/routes.js